import React from "react";
import EntranceLandingPage from "./EntranceLandingPage";

/**
 * Kiosk / full-screen scanner mode.
 *
 * Phase 1 closure §2 — this used to be a second scanner implementation that
 * drifted from the primary one. It is now a thin wrapper that reuses the
 * same InlineScanner via ``EntranceLandingPage`` with a ``focus`` flag.
 * All business logic (ticket / guest-list / reservation / walk-in / staff
 * badge / override routing / entrance.override gating) is shared.
 */
export default function EntranceDoorPage() {
  return <EntranceLandingPage focus={true} />;
}
